var _mask, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavouriteIconOutlineWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 18,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66675 2.5H18.7272V18.7508H1.66675V2.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18639 10.1026C4.35472 13.7376 8.97056 16.6768 10.1972 17.4043C11.4281 16.6693 16.0772 13.6976 17.2081 10.1059C17.9506 7.78426 17.2614 4.84342 14.5231 3.96092C13.1964 3.53509 11.6489 3.79426 10.5806 4.62092C10.3572 4.79259 10.0472 4.79592 9.82222 4.62592C8.69056 3.77509 7.21222 3.52592 5.86472 3.96092C3.13056 4.84259 2.44389 7.78342 3.18639 10.1026ZM10.1981 18.7509C10.0948 18.7509 9.9923 18.7259 9.89897 18.6751C9.63813 18.5326 3.49397 15.1459 1.99647 10.4843C1.99563 10.4843 1.99563 10.4834 1.99563 10.4834C1.05563 7.54843 2.1023 3.8601 5.48147 2.77093C7.06813 2.2576 8.7973 2.48343 10.1956 3.36593C11.5506 2.50927 13.3506 2.2726 14.9056 2.77093C18.2881 3.86177 19.3381 7.54926 18.399 10.4834C16.9498 15.0918 10.7606 18.5293 10.4981 18.6734C10.4048 18.7251 10.3015 18.7509 10.1981 18.7509Z",
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1282 8.85357C14.8057 8.85357 14.5324 8.60607 14.5057 8.27941C14.4507 7.59441 13.9924 7.01607 13.3399 6.80524C13.0107 6.69857 12.8307 6.34607 12.9366 6.01857C13.0441 5.69024 13.3932 5.51191 13.7232 5.61524C14.8591 5.98274 15.6549 6.98857 15.7524 8.17774C15.7799 8.52191 15.5241 8.82357 15.1799 8.85107C15.1624 8.85274 15.1457 8.85357 15.1282 8.85357Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteIconOutlineWhite);
export default __webpack_public_path__ + "static/media/favourite_icon_outline_white.c66e9713d91e7a734bd89f9540b29a21.svg";
export { ForwardRef as ReactComponent };